import { render } from "./AuthModal.vue?vue&type=template&id=8062b4ec"
import script from "./AuthModal.vue?vue&type=script&lang=js"
export * from "./AuthModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/AuthModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8062b4ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8062b4ec', __exports__)) {
    console.log('reload')
    api.reload('8062b4ec', __exports__)
  }
  
  module.hot.accept("./AuthModal.vue?vue&type=template&id=8062b4ec", () => {
    console.log('re-render')
    api.rerender('8062b4ec', render)
  })

}


export default __exports__